import { Button } from '@mui/material';
import { Link } from '../../../components';
import { useQuery } from 'react-query';
import { IBuild, IResponse } from '../../../models';
import { getPersonBuilds } from '../../../fetch';
import { useContext, useMemo } from 'react';
import { UserContext } from '../../../context';

export const MyHomeOptionsButton = () => {
  const { user } = useContext(UserContext);
  const personId = user?.externalUser?.personId;
  const { isLoading, data: builds } = useQuery<IResponse<IBuild[]>, Error>(
    ['contract-builds'],
    async () =>
      await getPersonBuilds(personId, {
        perPage: '2147483647' // get all records
      }),
    {
      enabled: !!personId
    }
  );
  const hasMultipleBuilds = useMemo(() => builds?.records?.length > 1, [builds]);
  return personId ? (
    <Button
      variant="contained"
      sx={{
        width: { xs: '100%', md: '250px' }
      }}
      component={Link}
      to={
        hasMultipleBuilds
          ? '/my-build?homeownerPortal=true'
          : `/my-build/${builds?.records?.[0]?.buildId}`
      }
      type="white"
      disabled={isLoading || builds?.records?.length === 0}
    >
      My Home Options
    </Button>
  ) : null;
};
